// extracted by mini-css-extract-plugin
export default {"chartsList_container":"ChartsList_chartsList_container__pBKyt"};